// Specialization Section with Fixed Parallax
import { motion, useScroll, useTransform } from 'framer-motion';

const Specialization = () => {
  const { scrollY } = useScroll();
  const backgroundY = useTransform(scrollY, [0, 1000], [0, -150]);

  return (
    <>
      {/* Mobile Version */}
      <div
        className="d-block d-sm-none"
        style={{ padding: '50px 20px', textAlign: 'center' }}
      >
        <h2
          style={{
            color: '#4f047a',
            fontSize: '2rem',
            fontWeight: 700,
            marginBottom: '20px',
          }}
        >
          Our Specialization
        </h2>
        <p
          style={{
            color: '#333',
            textTransform: 'uppercase',
            fontSize: '1.1rem',
            fontWeight: 600,
            marginBottom: '10px',
          }}
        >
          We work at{' '}
          <span style={{ color: '#a2bf0d' }}>all scales and all sectors.</span>
        </p>
        <p
          style={{
            color: '#333',
            textTransform: 'uppercase',
            fontSize: '1.1rem',
            fontWeight: 600,
          }}
        >
          We create cultural, corporate, residential and other spaces with their
          surroundings
        </p>
      </div>

      {/* Desktop Version with Fixed Parallax */}
      <div
        className="d-none d-sm-block"
        style={{
          position: 'relative',
          padding: '150px 0',
          overflow: 'hidden',
          minHeight: '500px',
        }}
      >
        {/* Parallax Background - Only this moves */}
        <motion.div
          style={{
            position: 'absolute',
            top: '-180px',
            left: 0,
            right: 0,
            bottom: '-180px',
            backgroundImage: 'url(/images/specialization/our-spec.jpg)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            y: backgroundY,
            zIndex: 0,
          }}
        />

        {/* Content - Stays static */}
        <div
          className="container"
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 20px',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <div className="row">
            <div style={{ maxWidth: '600px' }}>
              <h2
                style={{
                  color: '#4f047a',
                  fontSize: '3rem',
                  fontWeight: 700,
                  marginBottom: '25px',
                  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
                }}
              >
                Our Specialization
              </h2>
              <p
                style={{
                  color: '#333',
                  textTransform: 'uppercase',
                  fontSize: '1.3rem',
                  fontWeight: 600,
                  marginBottom: '15px',
                  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
                }}
              >
                We work at{' '}
                <span style={{ color: '#a2bf0d' }}>
                  all scales and all sectors.
                </span>
              </p>
              <p
                style={{
                  color: '#333',
                  textTransform: 'uppercase',
                  fontSize: '1.3rem',
                  fontWeight: 600,
                  textShadow: '1px 1px 2px rgba(255,255,255,0.5)',
                }}
              >
                We create cultural, corporate, residential and other spaces with
                their surroundings
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Specialization;
